import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AnimationItem} from 'lottie-web';
import {AnimationOptions} from 'ngx-lottie';
import {SUBSCRIPTIONS} from '../../common/utils/constants';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {PageTitleService} from '../../services/page-title.service';
import {AutoUnsubscribe} from '../../decorators/auto-unsubscribe.decorator';
import {ToastrMessagesProvider} from '../../services/toastr-messages.service';
import {ToastContainerDirective} from 'ngx-toastr';
import {AuthService} from '../shared/services/auth.service';

declare global {
  interface Window {
    UserWay: any;
    dataLayer: any;
  }
}

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
})
@AutoUnsubscribe()
export class AuthLayoutComponent implements OnInit, OnDestroy {
  @ViewChild(ToastContainerDirective, {static: true})
  toastContainer: ToastContainerDirective;
  html = null;
  widgetPreloaded = false;

  options: AnimationOptions = {
    path: './assets/lottie/widget-anim.json',
  };

  constructor(
    public authService: AuthService,
    private pageTitleService: PageTitleService,
    private router: Router,
    private toastrMessagesProvider: ToastrMessagesProvider,
  ) {}

  animationCreated(animationItem: AnimationItem): void {}

  ngOnInit(): void {
    this.toastrMessagesProvider.commonMessageContainer = this.toastContainer;
    this.html = document.getElementsByTagName('html');
    this.html[0].classList.add('login-page');
    this.pageTitleService.setPageTitle(this.router.url);
    this[SUBSCRIPTIONS].add(
      this.router.events
        .pipe(filter((event: NavigationEnd) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.pageTitleService.setPageTitle(event.url);
        }),
    );
  }

  openWidget(): void {
    if (window.UserWay) {
      window.UserWay.widgetOpen();
    }
  }

  preloadWidget(): void {
    if (!this.widgetPreloaded && window.UserWay) {
      this.widgetPreloaded = true;
      window.UserWay.preloadWidget();
    }
  }

  ngOnDestroy(): void {
    this.html?.[0].classList.remove('login-page');
  }
}
